import { useEffect, useState } from "react";
import Header from "../../Common/Header";
import Payment from "../../Components/Payment";

const PaymentPage = () => {
  return (
    <>
      <Header />
      <Payment />
    </>
  );
};

export default PaymentPage;
